module.exports = __webpack_public_path__ + "static/media/19_r_stena_85.42_0.48b03e7b.png";